import React from "react";
import "./Home.css";

const Home = () => {
  const steps = [
    { title: "Design Concept", image: "/images/design.jpg" },
    { title: "Engineering Drawing", image: "/images/engineering.jpg" },
    { title: "On Site Execution", image: "/images/onsite.jpg" },
    { title: "Off Site Production", image: "/images/offsite.jpg" },
    { title: "Supervision", image: "/images/supervision.jpg" },
    { title: "Handover", image: "/images/handover.jpg" },
  ];



  return (
    <div className="landing-container">
<header className="hero-animated">
  <div className="hero-images">
    <img src="/images/hero1.jpg" alt="Hero 1" className="hero-img" />
    <img src="/images/hero2.jpg" alt="Hero 2" className="hero-img" />
    <img src="/images/hero3.jpg" alt="Hero 3" className="hero-img" />
  </div>

  <div className="hero-overlay">
    <h1 className="tagline-animated">
      Curating Spaces with Design to Build Services
    </h1>
    <p className="subtagline">
      Transforming interiors with precision, elegance, and purpose.
    </p>
  </div>
</header>





<section className="steps-section">
  <h2 className="section-heading">Our Process</h2>
  <div className="steps-flow">
    {steps.map((step, index) => (
      <React.Fragment key={index}>
        <div className="step-card">
          <img src={step.image} alt={step.title} />
          <h3>{step.title}</h3>
        </div>
        {index < steps.length - 1 && (
          <div className="step-arrow">➝</div>
        )}
      </React.Fragment>
    ))}
  </div>
</section>


      <section className="intro-ribbon">
  <div className="ribbon-image">
    <img src="/images/sample.jpg" alt="Interior Sample" />
  </div>

  <div className="ribbon-content">
    <p>
      We offer a wide range of services for both residential and commercial spaces. — from concept to creation.  At the heart of our interior solutions lies a factory-driven approach that blends precision, speed, and consistency. 
      We specialize in modular kitchens, wardrobes, and complete home interiors — crafted with cutting-edge manufacturing techniques and minimal on-site intervention. Our use of mini-fix hardware ensures seamless assembly, cleaner aesthetics, and faster installations compared to traditional screw-based methods. Every component is pre-engineered for perfection, so your dream space is delivered with unmatched accuracy and finesse. Whether it’s innovative layout planning, or luxurious finishes, our dedicated team ensures every detail speaks elegance, comfort, and functionality.
    </p>
  </div>
</section>


      <section className="expertise-section">
  <h2 className="section-heading">Our Expertise</h2>

  <div className="expertise-flow">
    {[
      { icon: "🛠️", title: "Designers & Craftsmen" },
      { icon: "🖌️", title: "Customized Designs" },
      { icon: "📐", title: "Attention to Detail" },
      { icon: "🤝", title: "Transparent Pricing" },
      { icon: "💬", title: "Customer Support" },
      { icon: "🏠", title: "Residential + Commercial" },
      { icon: "🛡️", title: "Post-installation Warranty" },
    ].map((item, index, arr) => (
      <div className="expertise-step" key={index}>
        <div className="expertise-box">
          <div className="emoji-icon">{item.icon}</div>
          <p>{item.title}</p>
        </div>
        {index < arr.length - 1 && (
          <div className="arrow">{window.innerWidth > 768 ? "➝" : "⬇️"}</div>
        )}
      </div>
    ))}
  </div>
</section>

    </div>
  );
};

export default Home;
